import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#a6cc39",
        secondary: "#a6cc39",
        tableColor: "#E0E0E0",
        accent: "a6cc39"
      }
    }
  }
});
